var __jsx = React.createElement;
import Icons from '@modules/icons';
import React from 'react';
const PasswordCondition = _ref => {
  let {
    title,
    state
  } = _ref;
  return __jsx("div", {
    className: "flex flex-row items-center gap-2 ".concat(state ? ' text-success-main' : 'text-neutral-400')
  }, __jsx(Icons.circleFilledCheck, {
    size: 10
  }), __jsx("div", {
    className: "text-sm font-thin"
  }, title));
};
export default PasswordCondition;